import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import styles from "./ImageSlider.module.scss";
import { ReactNode, useMemo } from "react";
import useWindowSize from "../../../utils/useWindowSize";

interface Props {
  children: ReactNode;
  isCenter: boolean;
  numItems?: number;
}

export default function DetailSlider({ children, isCenter, numItems }: Props) {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: numItems ? numItems : 1,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: numItems ? numItems : 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: numItems ? numItems : 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: numItems ? numItems : 1,
    },
  };
  const isCarousel = useMemo(() => {
    return children instanceof Array && children.length > 1;
  }, [children]);
  const window = useWindowSize();

  return isCarousel ? (
    <Carousel
      ssr={true}
      centerMode={isCenter}
      infinite={true}
      itemClass={styles["carousel-item-padding"]}
      responsive={responsive}
      showDots={false}
      beforeChange={() => {
        if (typeof document !== "undefined") {
          const video = document.querySelector("video");
          if (video) video.pause();
        }
      }}
    >
      {children}
    </Carousel>
  ) : (
    <div
      style={{
        height: "100%",
        width: "100%",
        position: "relative",
        minHeight: window.width < 839 ? "30vh" : "50vh",
        boxSizing: "border-box",
        maxHeight: "650px",
      }}
    >
      <div
        style={{
          display: "block",
          overflow: "hidden",
          position: "absolute",
          inset: "0px",
          boxSizing: "border-box",
          margin: "0px",
          width: "100%",
          height: "100%",
        }}
      >
        {children}
      </div>
    </div>
  );
}
